// «Show me where» for the AppsFlyer API token: the Security Center screenshot with the AppsFlyer tokens
// card (1) and the "Manage your AppsFlyer tokens" link (2). Shared by the Connections row and the
// instruction text (modal and /guide). Positions are % of the 2740×1215 image.
import { t } from "../i18n";
import { GuideFigure } from "./GuideFigure";

export function AppsflyerFigure({ testId }: { testId: string }) {
  return (
    <GuideFigure
      wide
      testId={testId}
      summary={t("conn.appsflyer.figSummary")}
      src="/guides/appsflyer-security-center.png"
      alt={t("conn.appsflyer.figAlt")}
      boxes={[
        { left: 51.2, top: 44, width: 47.7, height: 25.4 },
        { left: 53.1, top: 62.6, width: 15.5, height: 4 },
      ]}
      pins={[
        { n: 1, left: 51.2, top: 44 },
        { n: 2, left: 53.1, top: 62.6 },
      ]}
      caption={[
        <>
          <em>{t("conn.appsflyer.fig1Em")}</em>
          {t("conn.appsflyer.fig1")}
        </>,
        <>
          <em>{t("conn.appsflyer.fig2Em")}</em>
          {t("conn.appsflyer.fig2")}
        </>,
      ]}
    />
  );
}
